<section *ngIf="bloqueios.length" class="card" role="status">
  <div class="topo">
    <span class="eyebrow">CartãoSiM · pendência</span>
    <span class="selo">Adesão bloqueada</span>
  </div>
  <p class="titulo">
    {{ bloqueios.length === 1 ? 'Uma fatura de assinatura cancelada' : bloqueios.length + ' faturas de assinatura cancelada' }}
    impede a adesão a um novo plano
  </p>
  <p class="nota">Não se regulariza pela Fila: abra um ticket para o financeiro.{{ naPausa ? '' : ' O atendimento de hoje segue normalmente.' }}</p>

  <ul class="itens">
    <li *ngFor="let b of bloqueios" class="item">
      <span class="item-texto">
        <strong>{{ rotulo(b) }} · {{ b.valor | brl }}</strong>
        <span class="item-sub">{{ b.plano }} · vencimento {{ b.vencimento }} · fatura {{ b.billId }}</span>
      </span>
      <span class="chip-ticket">Abra um ticket para o financeiro</span>
    </li>
  </ul>

  <div class="rodape">
    <button type="button" class="btn-copiar" (click)="copiarParaTicket()">{{ copiado ? 'Copiado!' : 'Copiar dados para o ticket' }}</button>
  </div>
</section>
